import { v4 as uuid } from 'uuid';

// eProtect SKD need uniq id with length less or equal 25
// For now in docs says it can be up to 256, but tested manually and world only with < 25
// Docs: https://developer.worldpay.com/assets/pdf/us-ecom-pdf/Worldpay_eProtect_Integration_Guide_V4.14.pdf
const ID_LENGTH = 25;
export const getRandomEProtectId = () => uuid().replaceAll('-', '').substring(0, ID_LENGTH);
